export default "__VITE_ASSET__N$ZvioUh__"